import Vue from 'vue';
import VueRouter from 'vue-router';
import OverlayPage from '@/components/overlay/OverlayPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:uuid?',
    name: 'Overlay',
    component: OverlayPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/overlay/',
  routes,
});

export default router;
